import React, { JSX } from 'react';
import { Link } from 'react-router-dom';
import { ServiceId } from '@/@types/application';
import { SERVICES } from '../constants';
import Button from './Button';
import RssButton from './RssButton';
import Section from './Section';
import SmallButton from './SmallButton';
import Style from './StatusDashboard.module.scss';
import StatusLegend from './StatusLegend';
import StatusPanel from './StatusPanel';
import Title from './Title';

// NOTE: CDNはトップに表示する必要はないが、コンパネから直リンクされているためページを用意
type ActiveServiceId = Exclude<ServiceId, 'cdn'>;
const activeServiceIds = Object.keys(SERVICES).filter((serviceId) => serviceId !== 'cdn');

const StatusDashboard: React.FC = (): JSX.Element => {
  return (
    <Section>
      <Title text="現在の状況">
        <RssButton href="https://www.sakura.ad.jp/rss/mainte.rdf" />
        <SmallButton text="さくらのサービス別通信状況（β）を見る" href="/network-status/" />
      </Title>
      <div className={Style.grid}>
        {activeServiceIds.map((serviceId) => {
          const id = serviceId as ActiveServiceId;
          return (
            <Link to={{ pathname: `/${serviceId}/` }} key={serviceId} className={Style.link}>
              <StatusPanel serviceId={id} location="top" />
            </Link>
          );
        })}
      </div>
      <StatusLegend />
      <Button text="過去の障害情報を見る" path="/archive/trouble/" />
    </Section>
  );
};

export default StatusDashboard;
